import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ModalService } from "ng-zorro-antd-mobile";
import * as moment from "moment";

@Component({
  selector: "app-form-item",
  templateUrl: "./form-item.component.html",
  styleUrls: ["./form-item.component.scss"],
  // scss作用域
})
export class FormItemComponent {
  @Input() itemType: string = "select";
  @Input() label: string = "";
  @Input() value: any = "";
  @Input() options: any[] = [];
  @Output() valueChange = new EventEmitter<any>();
  value1: any = "";

  get displayValue() {
    let placeholder = "请选择";
    if (this.itemType == "select") {
      const item = this.options.find((o) => o == this.value);
      if (item) {
        return item;
      }
    } else if (this.itemType == "date" && this.value) {
      return moment(this.value).format("YYYY-MM-DD");
    } else if (this.itemType == "multiple") {
      if (this.value && this.value.length > 0) {
        return this.options.filter((o) => this.value.indexOf(o.value) > -1);
      }
      return [];
    } else if (this.itemType == "flight") {
      const item = this.options.find((o) => o.value == this.value1);
      if (item) {
        return item.label;
      }
    }
    return placeholder;
  }

  searchKey: string = "";

  get flightOptions() {
    if (this.options.length > 0) {
      return this.options.filter((o) => o.label.indexOf(this.searchKey) > -1);
    }
    return [];
  }

  onValueChange(event) {
    console.log("???");
    if (this.itemType == "select") {
      if (event.length > 0) {
        this.value1 = event[0];
      }
    } else if (this.itemType == "date" && event.date) {
      this.value1 = moment(event.date).format("YYYY-MM-DD");
    } else if (this.itemType == "textarea") {
      this.valueChange.emit(event.detail.value);
    } else if (this.itemType == "flight") {
      this.value1 = event;
    } else if (this.itemType == "multiple") {
      this.value1 = event;
      // 从this.options中筛选出checked为true的
      let list = this.options.filter((o) => o.checked == true);
      this.value1 = list.map((item) => item.value);
    }
    console.log("onValueChange", event, this.value1);
  }

  modal1: boolean = false;

  showModal() {
    this.modal1 = true;
  }

  removeTag($event, item) {
    $event.stopPropagation();
    ModalService.alert("删除", "确认移除?", [
      { text: "取消", onPress: () => console.log("cancel") },
      {
        text: "确认",
        onPress: () => {
          this.value = this.value.filter((o) => o != item);
        },
      },
    ]);
  }

  selectRadioItem(event) {
    this.value1 = event;
  }

  footer = [
    {
      text: "Ok",
      onPress: () => {
        console.log("ok");
        this.onClose();
      },
    },
  ];

  constructor(private _modal: ModalService) {}

  onClose() {
    this.modal1 = false;
  }

  onConfirm() {
    console.log("onConfirm", this.value1);

    this.value = this.value1;
    this.valueChange.emit(this.value1);
    this.modal1 = false;
  }
}
